
export const privacySetting = {
    terms_conditions: 'Terms & Conditions',
    privacy_policy: 'Privacy Policy',
    marketing_message: 'Marketing Message',
    marketing_consent: {
        marketing_message: 'I am interested in and would like to receive information about products, services, free, gifts, discounts, promotions and other relevant activities from ShopDD and affilliated Buzzebees Co.,Ltd, Please allow us at least 1 channel.',
        email: 'Email',
        sms: 'SMS',
        update: 'Update'
    },
    confirm_popup: {
        title: 'Confirm?',
        msg: 'You will miss the opportunity to receive information about products, services, free items, discounts, promotions and activities, Do you confirm?',
        btnOk: 'Back to Setting',
        btnCancel: 'Cancel'
    },
    success: {
        title: 'Successfully!',
        btn: 'OK'
    }
}
